/**
 * Centralised typed access to Vite environment variables.
 *
 * All REST calls must go through the **API Gateway** (VITE_API_BASE_URL),
 * per docs/architecture-gui.md.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080",
  /** Must match `chikitsalink.appointment.zone` in appointment-service (slot “today”). */
  appointmentCalendarZone:
    import.meta.env.VITE_APPOINTMENT_ZONE ?? "Asia/Kolkata",
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL ?? "http://localhost:8180",
    realm: import.meta.env.VITE_KEYCLOAK_REALM ?? "docapp",
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT ?? "react-web",
  },
  razorpayKeyId: import.meta.env.VITE_RAZORPAY_KEY_ID ?? "",
} as const;
